import React from "react";
import PropTypes from "prop-types";

function Eye({ className, style, fill, defaultWidth, defaultHeight }) {
  return (
    <svg
      viewBox="0 0 25 16"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={fill} fill-rule="nonzero">
        <path
          d="M24.102481 7.20452C23.888371 6.916368 18.78687.14898 12.271328.14898 5.755787.14898.65405 6.916368.440175 7.204243c-.202781.273369-.202781.644139 0 .917507.213875.288151 5.315612 7.05554 11.831153 7.05554 6.515541 0 11.617044-6.767435 11.831153-7.05531.203062-.273322.203062-.644368 0-.91746zm-11.831153 6.418125c-4.79939 0-8.956172-4.491652-10.186668-5.96004 1.228905-1.469677 5.37698-5.95898 10.186668-5.95898 4.799156 0 8.955657 4.490868 10.186668 5.96004-1.228904 1.469631-5.37698 5.95898-10.186668 5.95898z"
        />
        <path d="M12.271328 2.999178c-2.613968 0-4.74069 2.092309-4.74069 4.66398 0 2.571671 2.126722 4.66398 4.74069 4.66398s4.74069-2.092309 4.74069-4.66398c0-2.571671-2.126722-4.66398-4.74069-4.66398zm0 7.77327c-1.74274 0-3.160429-1.394797-3.160429-3.10929 0-1.714494 1.417737-3.10929 3.16043-3.10929 1.742691 0 3.160428 1.394796 3.160428 3.10929 0 1.714493-1.41769 3.10929-3.160429 3.10929z" />
      </g>
    </svg>
  );
}

Eye.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
};

Eye.defaultProps = {
  className: undefined,
  defaultHeight: 16,
  defaultWidth: 25,
  fill: "#D2E3E4"
};

export default Eye;
